import { render, staticRenderFns } from "./DCClientSignatureView.vue?vue&type=template&id=510532f0&"
import script from "./DCClientSignatureView.vue?vue&type=script&lang=js&"
export * from "./DCClientSignatureView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports